import { get, post } from ".";

export const getCompanysApi = async () => {
  return await get(`companys`);
};

export const addCompanyApi = async (companyName) => {
  return await post(`companys/new-company?companyName=${companyName}`);
};